<div class="flex w-full flex-col">
    <div class="fixed top-0 z-10 flex h-18 w-full items-center justify-between bg-white px-6 shadow-sm">
        <div class="w-10">
            <img
                src="images/logo/brand-amex.svg"
                alt="American Express Logo"
            />
        </div>
        <user></user>
    </div>
    <section class="mt-18 flex flex-grow flex-col items-center justify-center">
        <div class="flex w-full items-center justify-center">
            <div class="bg-card my-6 w-80 gap-6 rounded-xl text-center shadow-xl sm:w-120">
                <section class="flex flex-col items-center justify-center gap-2 px-6 pb-4 pt-6 text-lg font-medium">
                    <mat-icon
                        svgIcon="mat_outline:check_circle"
                        class="text-green-600 icon-size-8"
                    ></mat-icon>
                    <h2 class="text-lg">Your Merchant setup is complete!</h2>
                </section>
                <section class="flex flex-col px-6">
                    <p>Your Payment Page URL is ready to use.</p>
                    <p>Share this link with your customers to start receiving payments</p>
                    <div
                        class="mt-4 flex cursor-pointer items-center justify-center gap-1 text-primary"
                        [cdkCopyToClipboard]="baseUrl + '/' + merchant?.vanityUrl"
                        (click)="copiedToClipboard()"
                    >
                        <span>{{ baseUrl }}/{{ merchant?.vanityUrl }}</span
                        ><span
                            ><mat-icon
                                svgIcon="mat_outline:content_copy"
                                class="text-primary"
                            ></mat-icon
                        ></span>
                    </div>
                </section>
                <section class="flex items-center justify-center px-6 py-4">
                    <!-- <button mat-stroked-button color="primary">Cancel</button> -->
                    <button
                        mat-flat-button
                        color="primary"
                        class="min-w-32"
                        (click)="done()"
                    >
                        Done
                    </button>
                </section>
            </div>
        </div>
    </section>

    <section
        class="px-6 py-4 text-sm text-neutral-500"
        [innerHTML]="copyrights"
    ></section>
</div>
